import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, orderByDsc } from './format'


export function newTransfer(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_TRANSFER_START", payload: "" })
            console.log("new Transfer START", {data})
            const res = await axios.post('/transfers/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_TRANSFER_ERROR", dispatch) ){                
				dispatch({ type: "NEW_TRANSFER", payload: res.data })
				dispatch({ type: "CREATE_TRANSFER_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new transfer ", err);
            dispatch({
                type: "CREATE_TRANSFER_ERROR",
                payload: err
            })
        }
    }
}

export function fetchTransfers() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_TRANSFERS_START", payload: "" })
            
            console.log("fetch Transfer START")
            const res = await axios.get('/transfers/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_TRANSFERS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_TRANSFERS",
                    payload: formatList(orderByDsc(res.data, "transfer_creation_date"), "transfer_id")
                })
                dispatch({ type: "FETCH_TRANSFERS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get transfers list ", err);
            dispatch({ type: "FETCH_TRANSFERS_ERROR", payload: err })
        }
    }
}


export function updateTransfer(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_TRANSFER_START", payload: "" })
            
            console.log("update Transfer START")
            const res = await axios.post("/transfers/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_TRANSFER_ERROR", dispatch) ){  
                
				dispatch({
                    type: "UPDATE_TRANSFER",
                    payload: data
                })
				dispatch({ type: "UPDATE_TRANSFER_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update transfer ", err);
            dispatch({
                type: "UPDATE_TRANSFER_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteTransfer(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_TRANSFER_START", payload: "" })

            console.log("delete transfer START")
            const res = await axios.post("/transfers/delete", {data: data.transfer_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_TRANSFER_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_TRANSFER",
                    payload: data,
                })
                dispatch({ type: "DELETE_TRANSFER_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete transfer ", err);
            dispatch({
                type: "DELETE_TRANSFER_ERROR",
                payload: err
            })
        }
    }
}

